<template>
  <table v-show="showTaxes">
    <tbody>
      <tr v-for="(tax, index) of visibleTaxes" :key="index">
        <translate tag="td" :tt="{ taxType: tax.type }">
          Excludes {taxType} tax (paid on arrival)
        </translate>
        <td>
          <pu-price :price="tax.amount" :display-original-price="true" />
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import { QuoteArrivalTax } from '../../quote/schema'

@Component
class ArrivalTaxes extends Vue {
  @Prop()
  taxes: QuoteArrivalTax[]

  get showTaxes(): boolean {
    return this.taxes.length > 0
  }

  get visibleTaxes(): QuoteArrivalTax[] {
    return this.taxes.filter((tax) => !tax.isHidden)
  }
}

export default toNative(ArrivalTaxes)
</script>
<style scoped>
table {
  font-size: var(--body);
  border-top: 1px solid #ccc;
}
table tr td:last-of-type {
  text-align: right;
}
</style>
